export default "__VITE_ASSET__CHeXYhbZ__"